module.exports = __webpack_public_path__ + "static/media/MongoAbout.bfa4d37e.png";